

<main class="d-flex flex-column vh-100" *ngIf="!isLanding">
    <app-header [path]="routePath" (sidebar)="sidebarAction($event)" [toggle]="isSidebar" *ngIf="!headerDisplay"></app-header>
    <lib-toolbar *ngIf="mobileHeader"></lib-toolbar>
    <mat-sidenav-container class="main-container">
        <mat-sidenav #sidenav mode="side"  class="example-sidenav" [fixedInViewport]="options.value.fixed"
            [fixedTopGap]="options.value.top" [fixedBottomGap]="options.value.bottom" [opened]="isSidebar">
            <app-sidemenu (sidebar)="sidebarAction($event)" [toggle]="isSidebar"></app-sidemenu>
        </mat-sidenav>
        <mat-sidenav-content [formGroup]="options" (click)="closeSideNav($event)">
            <ng-container *ngIf="!headerDisplay">
            <div [ngClass]="{'container-fluid': true, 'p-0':applyP0Class}">
                <router-outlet></router-outlet>
            </div>
        </ng-container>
        <ng-container *ngIf="headerDisplay">
                <router-outlet></router-outlet>
        </ng-container>
        </mat-sidenav-content>
    </mat-sidenav-container> 
</main>

<ng-container *ngIf="isLanding">
    <router-outlet></router-outlet>
</ng-container>